import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShoppingCart, MessageCircle, ArrowRight, ArrowLeft } from 'lucide-react';

export default function FarmHelpPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 via-emerald-50 to-emerald-700 flex flex-col">
      {/* Back Button */}
      <div className="p-6">
        <button
          className="flex items-center gap-2 text-gray-800 font-medium hover:gap-3 transition-all"
          onClick={() => navigate('/')}
        >
          <ArrowLeft size={20} />
          <span className="text-lg">Back</span>
        </button>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col items-center justify-start px-6 pt-12">
        {/* Header */}
        <div className="text-center mb-8 max-w-lg">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            How can we help you?
          </h1>
          <p className="text-gray-700 text-base leading-relaxed">
            Choose an option below to get started with your farm-fresh experience
          </p>
        </div>

        {/* Cards Container */}
        <div className="w-full max-w-lg space-y-6 mt-8">
          {/* Make an Order Card */}
          <div className="bg-white rounded-3xl shadow-lg p-8 hover:shadow-xl transition-shadow">
            <div className="flex items-start justify-between mb-4">
              <h2 className="text-2xl font-bold text-gray-900">
                Make an order
              </h2>
              <ShoppingCart size={40} strokeWidth={1.5} className="text-gray-900" />
            </div>
            
            <p className="text-gray-700 text-base mb-6 leading-relaxed">
              Browse our fresh selection and place an order for delivery or pickup
            </p>
            
            <button
              type="button"
              className="flex items-center gap-2 text-gray-900 font-semibold hover:gap-3 transition-all"
              onClick={() => navigate("/order")}
            >
              <span className="text-base">Start Order</span>
              <ArrowRight size={20} />
            </button>
          </div>

          {/* Send a Message Card */}
          <div className="bg-white rounded-3xl shadow-lg p-8 hover:shadow-xl transition-shadow">
            <div className="flex items-start justify-between mb-4">
              <h2 className="text-2xl font-bold text-gray-900">
                Send a Message
              </h2>
              <MessageCircle size={40} strokeWidth={1.5} className="text-gray-900" />
            </div>
            
            <p className="text-gray-700 text-base mb-6 leading-relaxed">
              Browse our fresh selection and place an order for delivery or pickup
            </p>
            
            <button
              type="button"
              className="flex items-center gap-2 text-gray-900 font-semibold hover:gap-3 transition-all"
              onClick={() => navigate("/contact")}
            >
              <span className="text-base">Send Message</span>
              <ArrowRight size={20} />
            </button>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="py-8 text-center">
        <p className="text-white text-sm">
          Copyright © 2025 AADA. All rights reserved.
        </p>
      </div>
    </div>
  );
}